import React, {useContext} from "react";

export const Lotto12v2Context = React.createContext();

export const useLotto12v2 = () => useContext(Lotto12v2Context);